import type {
  AnalysesPageContext,
  LpuCardsPage,
  PartnerCardContextItem,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

const EMPTY_LPU_CARDS_PAGE: LpuCardsPage = { __items__: [] }

export function isAnalysesFiltersEnabled(context: AnalysesPageContext): boolean {
  return Boolean(context.feature_flags.ff_analyses_filters)
}

export function getAnalysesCardsPage(
  context: AnalysesPageContext,
  isFiltersEnabled: boolean,
): LpuCardsPage {
  return (isFiltersEnabled ? context.all_cards_page : context.lpu_cards_page)
    || EMPTY_LPU_CARDS_PAGE
}

export function getAnalysesInitialExtras(
  context: AnalysesPageContext,
  isFiltersEnabled: boolean,
): PartnerCardContextItem[] {
  if (isFiltersEnabled) {
    return []
  }

  return context.partner_cards || []
}
